import { TableColumnPreview } from "../state/types";

type FormulaTableColumnPreview = TableColumnPreview & {
  type: "formula";
};

export const isFormulaColumnPreview = (
  preview: TableColumnPreview | undefined
): preview is FormulaTableColumnPreview => preview?.type === "formula";
